export default "__VITE_ASSET__0aa716d0__"